import type { ErrorEvent, EventHint } from '@sentry/react-router'
import { isRouteErrorResponse } from 'react-router'

export function beforeSend(event: ErrorEvent, hint: EventHint) {
  const error = hint.originalException
  if (isRouteErrorResponse(error) && 'internal' in error && error.internal === true && error.status === 404) {
    // React Router: no route matches URL.
    return null
  }
  return event
}
